import React, { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { loginUser } from '../../services/loginService';

import './style.css';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { Link, useHistory } from 'react-router-dom';
import { authUser } from '../../services/authService';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();

  const handleTyping = (
    field: string,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = event.target;
    field === 'email' ? setEmail(value) : setPassword(value);
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();

    try {
      const { token } = await loginUser(email, password);
      localStorage.setItem('token', token);
      toast.success(
        <p>
          Login realizado com sucesso! :)
          <br />
          Redirecionando para a busca.
        </p>,
      );
      history.push('/search');
    } catch (error) {
      error && error.response && error.response.data && error.response.data.msg
        ? toast.error(error.response.data.msg)
        : toast.error('Algo deu errado.');
    }
  };

  useEffect(() => {
    (async () => {
      await authUser();
      history.push('/search');
    })();
  }, []);

  return (
    <div className='login'>
      <Form onSubmit={handleSubmit} className='login-form'>
        <Form.Group className='mb-3' controlId='formBasicEmail'>
          <Form.Label>Email</Form.Label>
          <Form.Control
            onChange={(event) => handleTyping('email', event)}
            type='email'
            placeholder='Insira seu e-mail'
          />
        </Form.Group>

        <Form.Group className='mb-3' controlId='formBasicPassword'>
          <Form.Label>Senha</Form.Label>
          <Form.Control
            autoComplete='true'
            onChange={(event) => handleTyping('password', event)}
            type='password'
            placeholder='Insira sua senha'
          />
          <div>
            <Link to='/users/reset'>Esqueceu sua senha?</Link>
          </div>
          <Form.Text className='text-muted'>
            Seus dados não serão compartilhados.
          </Form.Text>
        </Form.Group>
        <div id='login-buttons'>
          <Button variant='primary' type='submit'>
            Login
          </Button>
          <Button variant='secondary' onClick={() => history.push('/register')}>
            Cadastre-se
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default Login;
